<template>
  <div>
    <SlideShowSection />
    <FeaturedPropertiesSection />
    <FeaturedTerrainsSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import FeaturedPropertiesSection from "../components/sections/FeaturedPropertiesSection.vue";
import FeaturedTerrainsSection from "../components/sections/FeaturedTerrainsSection.vue";

export default {
  components: {
    SlideShowSection,
    FeaturedPropertiesSection,
    FeaturedTerrainsSection,
  },
};
</script>
